<template>
<div>
<svg id='metro-map' viewBox="0 0 1515 295">
    <g transform="translate(-10 190)">
        <g id='M1' class='metro-line' transform="translate(100 0)">
            <g class='metro-line-label' transform="translate(-60 -13)" @click="selectLine('M1')" ><rect/><text x="9" y="18">M1</text></g>
            <line x2="1180" />
            <line x1="1180" x2="1230" y2="50"/>
            <line x1="1230" x2="1330" y1="50" y2="50"/>   
            <g class='metro-line-label' transform="translate(1350 37)" @click="selectLine('M1')"><rect/><text x="9" y="18">M1</text></g>
        </g>
        
        <g id='M2' class='metro-line' transform="translate(500 -20)">
            <g class='metro-line-label' transform="translate(-60 -18)" @click="selectLine('M2')"><rect/><text x="9" y="18">M2</text></g>
            <line x2="780"/>
            <line x1="780" x2="830" y2="-50"/>
            <line x1="830" x2="930" y1="-50" y2="-50"/>   
            <g class='metro-line-label' transform="translate(950 -63)" @click="selectLine('M2')"><rect/><text x="9" y="18">M2</text></g>
        </g>

        <g transform="translate(100)">
            <MetroMapStation :station="stations[0]" :selected="isSelected(stations[0])" @click="select" />
            <MetroMapStation :station="stations[1]" :selected="isSelected(stations[1])" @click="select" t="50" />
            <MetroMapStation :station="stations[2]" :selected="isSelected(stations[2])" @click="select" t="100" />
            <MetroMapStation :station="stations[3]" :selected="isSelected(stations[3])" @click="select" t="150" />
            <MetroMapStation :station="stations[4]" :selected="isSelected(stations[4])" @click="select" t="200" />
            <MetroMapStation :station="stations[5]" :selected="isSelected(stations[5])" @click="select" t="250" />
            <MetroMapStation :station="stations[6]" :selected="isSelected(stations[6])" @click="select" t="300" />
            <MetroMapStation :station="stations[7]" :selected="isSelected(stations[7])" @click="select" t="350" />
            <MetroMapStation :station="stations[8]" :selected="isSelected(stations[8])" @click="select" t="400" />
            <MetroMapStation :station="stations[9]" :selected="isSelected(stations[9])" @click="select" t="450" />
            <MetroMapStation :station="stations[10]" :selected="isSelected(stations[10])" @click="select" t="500" />
            <MetroMapStation :station="stations[11]" :selected="isSelected(stations[11])" @click="select" t="550" />
            <MetroMapStation :station="stations[12]" :selected="isSelected(stations[12])" @click="select" t="600" />
            <MetroMapStation :station="stations[13]" :selected="isSelected(stations[13])" @click="select" t="650" />
            <MetroMapStation :station="stations[14]" :selected="isSelected(stations[14])" @click="select" t="700" />
            <MetroMapStation :station="stations[15]" :selected="isSelected(stations[15])" @click="select" t="750" />
            <MetroMapStation :station="stations[16]" :selected="isSelected(stations[16])" @click="select" t="800" />
            <MetroMapStation :station="stations[17]" :selected="isSelected(stations[17])" @click="select" t="850" />
            <MetroMapStation :station="stations[18]" :selected="isSelected(stations[18])" @click="select" t="900" />
            <MetroMapStation :station="stations[19]" :selected="isSelected(stations[19])" @click="select" t="950" />
            <MetroMapStation :station="stations[20]" :selected="isSelected(stations[20])" @click="select" t="1000" />
            <MetroMapStation :station="stations[21]" :selected="isSelected(stations[21])" @click="select" t="1050" />
            <MetroMapStation :station="stations[22]" :selected="isSelected(stations[22])" @click="select" t="1100" />
            <MetroMapStation :station="stations[23]" :selected="isSelected(stations[23])" @click="select" t="1150" />
        </g>

        <g transform="translate(1330 -70)">
            <MetroMapStation :station="stations[24]" :selected="isSelected(stations[24])" @click="select" class='tc' />
            <MetroMapStation :station="stations[25]" :selected="isSelected(stations[25])" @click="select" t="50" class='tc' />
            <MetroMapStation :station="stations[26]" :selected="isSelected(stations[26])" @click="select" t="100" class='tc' />
        </g>

        <g transform="translate(1330 50)">
            <MetroMapStation :station="stations[27]" :selected="isSelected(stations[27])" @click="select" class='tc' />
            <MetroMapStation :station="stations[28]" :selected="isSelected(stations[28])" @click="select" t="50" class='tc' />
            <MetroMapStation :station="stations[29]" :selected="isSelected(stations[29])" @click="select" t="100" class='tc' />
        </g>   
      <!--
        <g :id='stations[1].id' @click='select' class='metro-station' :class="getSelected(stations[1])" transform="translate(150)"><circle/><text> {{ stations[1].name }} </text></g>
        <g :id='stations[2].id' @click='select' class='metro-station' :class="getSelected(stations[2])" transform="translate(200)"><circle/><text> {{ stations[2].name }} </text></g>
        
        <g :id='stations[3].id' @click='select' class='metro-station' :class="getSelected(stations[3])" transform="translate(250)"><circle/><text> {{ stations[3].name }} </text></g>
        <g :id='stations[4].id' @click='select' class='metro-station' :class="getSelected(stations[4])" transform="translate(300)"><circle/><text> {{ stations[4].name }} </text></g>
        <g :id='stations[5].id' @click='select' class='metro-station' :class="getSelected(stations[5])" transform="translate(350)"><circle/><text> {{ stations[5].name }} </text></g>
        <g :id='stations[6].id' @click='select' class='metro-station' :class="getSelected(stations[6])" transform="translate(400)"><circle/><text> {{ stations[6].name }} </text></g>
        <g :id='stations[7].id' @click='select' class='metro-station' :class="getSelected(stations[7])" transform="translate(450)"><circle/><text> {{ stations[7].name }} </text></g>
        <g :id='stations[8].id' @click='select' class='metro-station' :class="getSelected(stations[8])" transform="translate(500)"><rect/><text> {{ stations[8].name }} </text></g>
        <g :id='stations[9].id' @click='select' class='metro-station' :class="getSelected(stations[9])" transform="translate(550)"><rect/><text> {{ stations[9].name }} </text></g>
        <g :id='stations[10].id' @click='select' class='metro-station' :class="getSelected(stations[10])" transform="translate(600)"><rect /><text> {{ stations[10].name }} </text></g>
        <g :id='stations[11].id' @click='select' class='metro-station' :class="getSelected(stations[11])" transform="translate(650)"><rect/><text> {{ stations[11].name }} </text></g>
        <g :id='stations[12].id' @click='select' class='metro-station' :class="getSelected(stations[12])" transform="translate(700)"><rect/><text> {{ stations[12].name }} </text></g>
        <g :id='stations[13].id' @click='select' class='metro-station' :class="getSelected(stations[13])" transform="translate(750)"><rect/><text> {{ stations[13].name }} </text></g>
        <g :id='stations[14].id' @click='select' class='metro-station' :class="getSelected(stations[14])" transform="translate(800)"><rect/><text> {{ stations[14].name }} </text></g>
        <g :id='stations[15].id' @click='select' class='metro-station' :class="getSelected(stations[15])" transform="translate(850)"><rect/><text> {{ stations[15].name }} </text></g>
        <g :id='stations[16].id' @click='select' class='metro-station' :class="getSelected(stations[16])" transform="translate(900)"><rect/><text> {{ stations[16].name }} </text></g>
        <g :id='stations[17].id' @click='select' class='metro-station' :class="getSelected(stations[17])" transform="translate(950)"><rect/><text> {{ stations[17].name }} </text></g>
        <g :id='stations[18].id' @click='select' class='metro-station' :class="getSelected(stations[18])" transform="translate(1000)"> <rect /><text> {{ stations[18].name }}</text></g>
        <g :id='stations[19].id' @click='select' class='metro-station' :class="getSelected(stations[19])" transform="translate(1050)"><rect/><text> {{ stations[19].name }} </text></g>
        <g :id='stations[20].id' @click='select' class='metro-station' :class="getSelected(stations[20])" transform="translate(1100)"><rect/><text> {{ stations[20].name }} </text></g>
        <g :id='stations[21].id' @click='select' class='metro-station' :class="getSelected(stations[21])" transform="translate(1150)"><rect/><text> {{ stations[21].name }} </text></g>
        <g :id='stations[22].id' @click='select' class='metro-station' :class="getSelected(stations[22])" transform="translate(1200)"><rect/><text> {{ stations[22].name }} </text></g>
        <g :id='stations[23].id' @click='select' class='metro-station' :class="getSelected(stations[23])" transform="translate(1250)"><rect/><text> {{ stations[23].name }} </text></g>
         
        <g transform="translate(1330 -70)">
            <g :id='stations[24].id' @click='select' class='metro-station tc' :class="getSelected(stations[24])" transform="translate(0)"><circle/><text> {{ stations[24].name }} </text></g>
            <g :id='stations[25].id' @click='select' class='metro-station tc' :class="getSelected(stations[25])" transform="translate(50)"><circle/><text> {{ stations[25].name }} </text></g>
            <g :id='stations[26].id' @click='select' class='metro-station tc' :class="getSelected(stations[26])" transform="translate(100)"><circle/><text> {{ stations[26].name }} </text></g>
        </g>
       

        <g transform="translate(1330 50)">
            <g :id='stations[27].id' @click='select' class='metro-station tc' :class="getSelected(stations[27])" transform="translate(0)"><circle/><text> {{ stations[27].name }} </text></g>
            <g :id='stations[28].id' @click='select' class='metro-station tc' :class="getSelected(stations[28])" transform="translate(50)"><circle/><text> {{ stations[28].name }} </text></g>
            <g :id='stations[29].id' @click='select' class='metro-station tc' :class="getSelected(stations[29])" transform="translate(100)"><circle/><text> {{ stations[29].name }} </text></g>
        </g>        
         -->
    </g>
</svg>

<div id='metro-map-selected-stations' class='selected-stations'>
    <div>
        <b-badge href="#" v-for="s in selectedStations" :key="s.id" @click='unselect(s.id)'>
        {{ s.name }}&nbsp;&nbsp;x
        </b-badge>
    </div>
 
    <div>
        <b-badge href="#" @click="selectAll()">Valitse kaikki asemat</b-badge>
        <b-badge v-if="selectedStations.length > 0" href="#"  @click="removeSelections()" class='rm'>Poista valinnat&nbsp;&nbsp;x</b-badge>
    </div>
</div>

</div>
</template>


<script>

import MetroMapStation from './MetroMapStation.vue';

export default {
    name: 'MetroMap',
    components: { MetroMapStation },

    props: ['stations'],
    data(){
        return {
            selectedStations: []
        }
    },
    methods: {
        selectE(event){
            let id = event.target.parentElement.id;
            this.select(id);
        },
        select(id){
            let selection = this.stations.find(station => station.id == id);
            if(selection){

                if(!this.selectedStations.includes(selection) )
                    this.selectedStations.push(selection);
                else
                    this.selectedStations = this.selectedStations.filter(station => station.id != id);
                
                 this.$emit('select', this.selectedStations);
 
            }
        },
        selectAll(){
            this.selectedStations = [];
            this.selectedStations.push(...this.stations);
            this.$emit('select', this.selectedStations);      
        },
        unselect(id){
            this.selectedStations = this.selectedStations.filter(station => station.id != id);
            this.$emit('select', this.selectedStations);
        },
        removeSelections(){
            this.selectedStations = [];
            this.$emit('select', this.selectedStations);
        },
        isSelected(station){
            return this.selectedStations.includes(station);
        },
        selectLine(line){
            this.selectedStations = this.stations.filter(station => station.lines.includes(line));
            this.$emit('select', this.selectedStations);
        }
    }
}
</script>

<style scoped >
    g.metro-station:hover {
        cursor: pointer;
    }

    g.metro-station:hover circle,
    g.metro-station.selected circle  {
        fill: #000;
    }
    
    g.metro-station:hover rect,
    g.metro-station.selected rect {
        fill: #000;
    }

    g.metro-station:hover > text {
        text-decoration: underline;
    }

   


</style>
